// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3GHoR","inputWrap":"styles_inputWrap__2Z30w","input":"styles_input__YsHSA"};